import {Grid, useMediaQuery} from "@mui/material";
import React, {ReactNode, useEffect, useState} from "react";
import {useGlobalContext} from "../../../../../services/context.service";
import {IUsers} from "../../../../../services/response.interface";
import {fnLocalizeFilter} from "../../../../../services/localize.service";
import {useAppDispatch} from "../../../../../hooks/redux";
import ComboBox from "../../../../UI/Input/ComboBox";
import Modal from "../../../../UI/Modal/Modal";
import {settingAPI} from "../../../../../services/settingAPI.service";
import InputFilled from "../../../../UI/Input/InputFilled";
import ComboboxMultiply from "../../../../UI/Input/ComboboxMultiply";
import {holderAPI} from "../../../../../services/holderAPI.service";
import InputPhone from "../../../../UI/Input/InputPhone";
import {handleCreateUser, handleUpdateUser} from "./utils/local.request.api";
import {checkPermission} from "../../../../../helpers/permissions";
import * as yup from 'yup';
import {useForm} from 'react-hook-form';
import {yupResolver} from '@hookform/resolvers/yup/dist/yup';
import {getMedia} from "../../../../../helpers/media";

interface IUserEditor extends Omit<IUsers, "personalAccountUserId"> {
}

const initialUser: IUserEditor = {
  id: -1,
  apiRole: 'SmartCardsReporter',
  active: true,
  email: '',
  firstName: '',
  lastName: '',
  phoneNumber: '',
  holders: [],
  listHolders: ''
};

interface IModalUserEditor {
  isShow: boolean;
  userId: number;

  handleClose(): void;
}


export default function ModalUserEditor({isShow = false, userId, handleClose}: IModalUserEditor) {
  /* Получаем языковую локаль */
  const {locale} = useGlobalContext();
  /* Инициализация медиа  */
  const matches = useMediaQuery(getMedia());
  const dispatch = useAppDispatch();

  const {data: dataHolder = {holders: []}} = holderAPI.useFetchAllClientsQuery({locale});
  const {data: dataRoles = {roles: []}} = settingAPI.useFetchUserRolesQuery({locale});
  const {data: dataUsers = {users: []}} = settingAPI.useFetchAllUsersQuery({locale});
  const [getUsers] = settingAPI.useLazyFetchAllUsersQuery();

  const [selectedUser, setSelectedUser] = useState<IUserEditor>(initialUser);
  const [phone, setPhone] = useState<string>('');

  useEffect(() => {
    let newUser = initialUser;
    if (userId !== -1) {
      newUser = dataUsers.users.filter(u => u.personalAccountUserId === userId)[0];
    }
    setSelectedUser({...newUser});
  }, [dataUsers, userId]);

  useEffect(() => {
    setTimeout(() => {

      if (selectedUser.id !== -1) {
        setPhone(selectedUser.phoneNumber)
      }
      selectedUser.phoneNumber !== "" && setValue('phone', selectedUser.phoneNumber);

    }, 100);
  }, [selectedUser])

  const phoneRegExp = /^38[0-9]{3}[0-9]{3}[0-9]{4}$/

  let validationSchema = yup.object().shape({
    phone: yup.string().required(`${fnLocalizeFilter(locale, '_lang.error.validation.fieldRequired')}`).matches(phoneRegExp, `${fnLocalizeFilter(locale, '_lang.error.validation.fieldErrorPhone')}`),
    holders: yup.array().required(``).min(1)
  });

  const {
    register, handleSubmit, setValue, formState: {errors}, getValues
  } = useForm({resolver: yupResolver(validationSchema)});

  /* Нажатие на ОК при создании пользователя */
  const handleBtnCreateUser = () => {
    const {holders, lastName, firstName, email, apiRole} = selectedUser;

    if (holders.length === 0) {

    }

    if (selectedUser.id === -1) {
      handleCreateUser({
        locale, firstName, lastName, phoneNumber: phone, holders, email, apiRole, dispatch
      }).then(res => {

        if (res) {
          getUsers({locale});
          handleClose();
        }
      });
    } else {
      handleUpdateUser({...selectedUser, phoneNumber: phone, locale, dispatch}).then(res => {

        if (res) {
          getUsers({locale});
          handleClose();
        }
      });
    }
  };

  const handleChangeClient = (arr: any[]) => {
    const newUser = {...selectedUser, holders: [...arr.map(a => ({holderId: a}))]}
    setSelectedUser(newUser);
  };

  const handleChangeApiRole = (roleId: number) => {
    const role = dataRoles.roles.filter(r => r.id === roleId)[0];
    const newUser = {...selectedUser, apiRole: role.roleName}
    setSelectedUser(newUser);
  }

  const handleChangeText = (field: string, e: any) => {
    const val = e.target.value;
    const newUser = {...selectedUser, [field]: val}
    setSelectedUser(newUser);
  }

  const handleChangePhone = (e: any) => {
    const value = e.target.value;
    setPhone(value);
    setValue('phone', value)
  };

  return <Modal
    handleBtnOk={checkPermission({permissionName: 'PersonalAccounts'}) > 1 ? handleSubmit(handleBtnCreateUser) : () => { }}
    isOpen={isShow}
    handleBtnCancel={handleClose}
    disabled={checkPermission({permissionName: 'PersonalAccounts'}) < 2}
    sx={{maxWidth: '400px'}}
  >
    <Grid item sx={{
      minWidth: '300px', minHeight: '500px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between'
    }}>


      <Grid>

        <InputFilled
          sx={{marginBottom: "1.3rem"}}
          label={fnLocalizeFilter(locale, '_lang.module.setting.users.titleLastName')}
          onChange={handleChangeText.bind(null, 'lastName')}
          value={selectedUser.lastName}
        />
        <InputFilled
          sx={{marginBottom: "1.3rem"}}
          label={fnLocalizeFilter(locale, '_lang.module.setting.users.titleFirstName')}
          onChange={handleChangeText.bind(null, 'firstName')}
          value={selectedUser.firstName}
        />
        <InputFilled
          sx={{marginBottom: "1.3rem"}}
          label={fnLocalizeFilter(locale, '_lang.module.setting.users.titleEmail')}
          onChange={handleChangeText.bind(null, 'email')}
          value={selectedUser.email}
        />
        {/*inputProps = {register('phone')}
                        error={!!errors.phone}
                        helperText={errors.phone ? (errors?.phone?.message as ReactNode) : ' '}
                       */}
        <InputPhone
          inputType={'filled'}
          inputProps={register('phone')}
          error={!!errors.phone}
          helperText={errors.phone ? (errors?.phone?.message as ReactNode) : ' '}
          label={fnLocalizeFilter(locale, '_lang.module.register.titlePhone')}
          value={phone}
          onChange={handleChangePhone}
          sx={{"& .MuiFilledInput-root:before, & .MuiFilledInput-root:after": {display: 'none'}}}
        />

        <ComboboxMultiply
          array={dataHolder.holders}
          optionName={'name'}
          fieldId={'holderId'}
          inputProps={register('holders')}
          error={!!errors.holders}
          selected={selectedUser && selectedUser.holders.map(h => h.holderId)}
          label={fnLocalizeFilter(locale, "_lang.module.clientList.titlePage")}
          onChange={handleChangeClient}
          id={'holders'}
          sx={{margin: ".2rem 0 1.4rem 0"}}
        />

        <ComboBox
          textStyle={{fontWeight: '700'}}
          data={dataRoles.roles}
          fieldLabelOption={'roleName'}
          label={fnLocalizeFilter(locale, '_lang.module.setting.users.titleApiRole')}
          fnOnChange={handleChangeApiRole}
          defaultValue={selectedUser.id !== -1 ? dataRoles.roles.filter(r => r.roleName === selectedUser.apiRole).map(r => (r.id))[0] : undefined}
        />

      </Grid>

    </Grid>
  </Modal>
}
